/**
 * Returns a random ID compose of character and strings at a specified length
 *
 * @param {number} length
 * @returns {string}
 */
function randomId(length) {
  // Set random ID as variable
  let generatedRandomId = '';
  // Set character map as constant
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  // Loop from zero to the length of the chosen random ID
  for (let i = 0; i < length; i += 1) {
    // Append a random character to the random ID
    generatedRandomId += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  // Return the random ID
  return generatedRandomId;
}
/**
 * Capitalises the first letter of a string
 *
 * @param {string} string
 * @param {mixed} defaultValue
 * @returns {mixed}
 */
function capitalise(string = '') {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 * Retrieves a search query parameter from the URL
 *
 * @param {string} parameter
 * @returns {string}
 */
function getSearchParameter(queryParameter, defaultValue) {
  // Retrieve search parameters from URL
  const searchParameters = new URLSearchParams(window.location.search);
  // Return based on whether the parameter exists, otherwise return the default value
  return searchParameters.has(queryParameter) ? searchParameters.get(queryParameter) : defaultValue;
}
/**
 * Returns the field value from the search result
 *
 * @param {object} fields
 * @param {string} fieldName
 * @param {string} defaultValue
 * @param {boolean} returnHighlights
 * @returns {string}
 */
function getFieldValue(fields, fieldName, defaultValue = 'Unknown', returnHighlights = false) {
  // Assign field to a constant
  const field = fields[fieldName];
  // Verify that the field exists
  if (field) {
    // Assign field value to field value highlights
    let fieldValueHighlights = field.Value;
    // Verify that highlights exist on this field
    if (field.Highlights) {
      // Conditionally assign joined highlights (or field value) to variable
      fieldValueHighlights = field.Highlights.length ? field.Highlights.join(' ') : field.Value;
    }
    // Return field value or joined highlights
    return returnHighlights ? fieldValueHighlights : field.Value;
  }
  // The field does not exist, return the default string
  return defaultValue;
}

export { getSearchParameter as a, capitalise as c, getFieldValue as g, randomId as r };
